import { useAuth } from '@/auth/AuthProvider';
import { useLeads } from '@/leads/LeadsProvider';
import FichaLead from '@/components/leads/FichaLead';

/**
 * Painel lateral do lead no funil e na lista — desde a VX, uma CASCA: o lead vem do
 * `LeadsProvider` (`leadAberto`), a ficha é a `FichaLead` (a mesma do chat). Etapas com
 * campo obrigatório continuam sendo pedidas ao pai (`aoPedirEtapa`), que monta o
 * `DialogoEtapa` — a ficha não monta diálogo nenhum.
 */
export default function PainelLead({ aoPedirEtapa }) {
  const { leadAberto: lead, fecharLead, clinicaId, autor, equipe, clinica } = useLeads();
  const { isGestor, papel } = useAuth();

  if (!lead) return null;

  return (
    <aside className="painel-lead" aria-label={`Lead ${lead.nome}`}>
      <header className="painel-cabecalho painel-cabecalho-casca">
        <span className="painel-sub">Ficha do lead</span>
        <button type="button" className="btn-fechar" onClick={fecharLead} aria-label="Fechar painel">
          ×
        </button>
      </header>
      <div className="painel-corpo">
        <FichaLead
          lead={lead}
          clinicaId={clinicaId}
          autor={autor}
          equipe={equipe}
          clinica={clinica}
          podeLancar={isGestor}
          papel={papel}
          aoPedirEtapa={aoPedirEtapa}
          abrirTodas
        />
      </div>
    </aside>
  );
}
